import { createStore } from 'satcheljs';
import FindControlViewState, {
    FindResultType,
} from 'owa-recipient-common/lib/store/schema/FindControlViewState';

export interface FindControlStore {
    viewState: FindControlViewState;
}

function populateFindControlInitialState(queryString: string, inForceResolve: boolean) {
    var initStore: FindControlStore = {
        viewState: {
            queryString: queryString,
            shouldShowFindResult: false,
            findResultSet: [],
            findResultType: FindResultType.None,
            findResultHightlightIndex: -1,
            isSearching: false,
            hasSearchedDirectory: false,
            findPeopleFeedbackManager: null,
            inForceResolve: inForceResolve,
        },
    };

    return createStore<FindControlStore>('FindControl', initStore)();
}
export default populateFindControlInitialState;
